import { lazy } from "@bridgesplit/ui";

const ExploreBorrow = lazy(() => import("./ExploreBorrow"));
const ExploreLoops = lazy(() => import("./ExploreLoops"));
const ExploreLend = lazy(() => import("./ExploreLend"));
const ExploreEarn = lazy(() => import("./ExploreEarn"));
const ExploreEcosystem = lazy(() => import("./ExploreEcosystem"));

export { ExploreBorrow, ExploreLend, ExploreEarn, ExploreLoops, ExploreEcosystem };
export * from "./markets";
